module.exports = __webpack_public_path__ + "img/LIENVIETPOSTBANK.2d141e07.svg";